import React from "react";

export const BreadcrumbListContext = React.createContext({
  listBreadcrumb: [],
  setListBreadcrumb: () => {},
});
